import axios from '../_helpers/axios'

const route = 'Expenses'.toLowerCase()
const createExpense = async (createBody) =>
  axios.post(`v1/${route}`, createBody)
const getExpenses = async (options) =>
  axios.get(
    `v1/${route}?${Object.keys(options)
      .map((key) => `${options[key] ? `&${key}=${options[key]}` : ''}`)
      .join('')}`
  )
const getExpense = async (id) => axios.get(`v1/${route}/${id}`)
const updateExpense = async (id, updateBody) =>
  axios.patch(`v1/${route}/${id}`, updateBody)
const deleteExpense = async (id) => axios.delete(`v1/${route}/${id}`)
export default {
  createExpense,
  getExpenses,
  getExpense,
  updateExpense,
  deleteExpense,
}
